import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import root from 'react-shadow';

interface ShadowWrapperProps {
  children: React.ReactNode;
}

const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children }) => {
  const shadowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!shadowRef.current) return;

    // Fetch Tailwind CSS from public folder
    fetch('/tailwind.css')
      .then(res => res.text())
      .then(css => {
        const style = document.createElement('style');
        style.textContent = css;

        // Inject style into the shadow root
        const shadowRoot = shadowRef.current!.shadowRoot;
        if (shadowRoot) {
          shadowRoot.prepend(style);
        }
      });
  }, []);

  return <root.div ref={shadowRef}>{children}</root.div>;
};

export default ShadowWrapper;